import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

import { useActiveHexContext } from 'shared/context';
import { useBigHex } from 'shared/hooks';
import { ZINDEX } from 'shared/constants';

export const CanvasHex = (): JSX.Element | null => {
  const {
    ctxHex,
    setCtxHex,
    bigHexPath,
    isBigHexViewActive,
    setIsBigHexViewActive,
    setIsBigHexSelected,
  } = useActiveHexContext();

  const { handleBigHexChange, getIsClickOutsideHex } = useBigHex();
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const initCanvas = () => {
    const canvas = canvasRef?.current;
    if (!canvas) return;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    const context = canvas.getContext('2d');
    if (!context) return;
    setCtxHex(context);
  };

  const closeBigHexView = () => {
    setIsBigHexViewActive(false);
    setIsBigHexSelected(false);
  };

  const handleMiniHexClick = () => {
    console.log('inside click');
  };

  const onCanvasClick = (event: React.MouseEvent<HTMLCanvasElement>) => {
    if (!bigHexPath) return;
    const { clientX: mouseX, clientY: mouseY } = event;
    const isClickOutsideHex = getIsClickOutsideHex(bigHexPath, mouseX, mouseY);
    if (isClickOutsideHex) closeBigHexView();
    else handleMiniHexClick();
    // TODO make it so events don't bubble to layer below
    // and you cannot move/zoom map when big hex view is active
  };

  useEffect(() => {
    if (!ctxHex) {
      initCanvas();
    }
    handleBigHexChange();
  }, [ctxHex, isBigHexViewActive]);

  return (
    <Canvas
      ref={canvasRef}
      onClick={onCanvasClick}
      onMouseMove={handleBigHexChange}
      style={{ display: isBigHexViewActive ? 'block' : 'none' }}
    />
  );
};

const Canvas = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${ZINDEX.CANVAS_HEX};
  overflow: hidden;
`;
